// Build resized URLs for images served by our /api/media proxy; other URLs pass through untouched.
const WIDTHS = [320, 480, 640, 800, 1024, 1280, 1600];

export function imgUrl(src, w) {
  if (!src || !w || !src.includes('/api/media/')) return src;
  return `${src}${src.includes('?') ? '&' : '?'}w=${w}`;
}

export function imgSrcSet(src, max = 1600) {
  if (!src || !src.includes('/api/media/')) return undefined;
  return WIDTHS.filter((w) => w <= max).map((w) => `${imgUrl(src, w)} ${w}w`).join(', ');
}
